import { Company } from '@/api/CompanyApi';
import { BaseEntity } from '@/api/EntityApi';

export enum UserStatus {
	INACTIVE = 'inactive',
	ACTIVE = 'active',
	SUSPENDED = 'suspended',
	WAITING_FOR_ACTIVATION = 'waiting_for_activation',
}

export enum UserType {
	ADMIN = 'admin',
	CLIENT = 'client',
}

interface BaseUser extends BaseEntity {
	firstName: string;
	lastName: string;
	email: string;
	password: string;
	status: UserStatus;
	userType: UserType;
	createdAt: string;
}

export interface ClientGroup extends BaseEntity {
	name: string;
	discountPercentage: number;
}

export interface Client extends BaseUser {
	phoneNumber: string;
	company: Company;
	canAddClients: boolean;
	clientGroup?: ClientGroup;
	userType: UserType.CLIENT;
}

export type AppUser = Client;
